import React, {useEffect} from 'react';
import track from 'utils/track';
import Impact from './impact.jsx';
import {usePhaseState} from 'funnel-schedule/phase-context';

export default function () {
  const {
    phases: {
      default: defaultSchedule = {
        phase: 'before'
      }
    }
  } = usePhaseState();
  const salesEnd = new Date(defaultSchedule.specialSalesTimer).getTime();
  const showTimer = salesEnd + 21600000 > new Date().getTime();

  const productId = 'tntg';
  const productSku = 'tntg';
  const productName = 'TNTG Impact Kit';
  const productSlug = 'tntg-impactkit-launch-wlc-30daytrial-st';
  const productValue = 97;

  useEffect(() => {
    track('Product Viewed', {
      product_id: productId,
      sku: productSku,
      name: productName,
      variant: productSlug,
      value: Number(productValue).toFixed(2),
      currency: 'usd'
    });
  });

  return <Impact salesOverride="sales97" noTimer={!showTimer} timerOverride={showTimer && salesEnd} noExitIntent />;
}
